import { TrackingModule } from 'TrackingModule';
import { buildFrame } from '../lokl-frame.js';
import { loadAwinAffiliateModule } from '../lokl-awin.js';
import { loadBuyButtonModule, BuyButtonConfig } from '../lokl-shopify.js';
// needed for shopify and awin
import './lokl-ad.scss';

// Hauptskript
document.addEventListener("DOMContentLoaded", function() {
    // Tracking-Modul initialisieren
    if (window.adConfig) {
        TrackingModule.init(window.adConfig);
    } else {
        console.warn('Keine adConfig gefunden. Tracking funktioniert möglicherweise nicht korrekt.');
    }

    var path = window.location.pathname;

    // Suche das div-Tag, das das Werbemittel auslöst
    document.querySelectorAll('[data-ad-container]').forEach(function(adContainer) {
        var postId = adContainer.getAttribute("data-post-id");
        var location = adContainer.getAttribute("data-location");
        var id = adContainer.getAttribute("id");

        var params = {
            postId: postId,
            location: location,
            path: path,
            id: id
        };

        // TODO configure correct URL for production, test, dev etc.
        // https://acws.lokl.hamburg/ad/emu
        fetch('https://ccws.lokl.hamburg/adcfg/emu', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(params)
        })
            .then(function (response) {
                return response.json();
            })
            .then(function (data) {
                var adType = data.adType;

                switch (adType) {
                    case 'buyButton':
                        const buyButtonConfig = new BuyButtonConfig(data.shopifyId);
                        buyButtonConfig.buttonType = data.buyButtonType;
                        buyButtonConfig.buttonDestination = "modal";
                        loadBuyButtonModule(data, adContainer, buyButtonConfig);
                        break;
                    case 'awinAffiliate':
                        loadAwinAffiliateModule(data, adContainer);
                        break;
                    default:
                        console.warn('Unbekannter Werbemitteltyp:', adType);
                }
                buildFrame(data, adContainer);
            })
            .catch(function (error) {
                console.error('Fehler:', error);
            })
    });
});



